import { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

export function NoInternet() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => {
      setOffline(false);
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (offline) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm" data-testid="no-internet-overlay">
        <div className="bg-white rounded-2xl shadow-2xl p-8 mx-4 max-w-sm w-full text-center animate-in fade-in zoom-in duration-300">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <WifiOff size={32} className="text-red-500" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">No Internet</h2>
          <p className="text-sm text-slate-500">Internet connection nahi hai. Please apna network check karein.</p>
          <div className="mt-5 flex items-center justify-center gap-1.5">
            <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse" />
            <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse" style={{ animationDelay: '300ms' }} />
            <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse" style={{ animationDelay: '600ms' }} />
          </div>
          <p className="text-xs text-slate-400 mt-3">Reconnect hone par automatically resume hoga</p>
        </div>
      </div>
    );
  }

  if (showReconnected) {
    return (
      <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] animate-in slide-in-from-top duration-300" data-testid="internet-reconnected">
        <div className="bg-emerald-600 text-white px-5 py-2.5 rounded-full shadow-lg flex items-center gap-2 text-sm font-medium">
          <div className="w-2 h-2 bg-emerald-300 rounded-full" />
          Internet Connected!
        </div>
      </div>
    );
  }

  return null;
}
